import type { ManCode } from '#api/tmsApiService'
import { readInternalStoredDataV1 } from './ConfigurationStorageDataV1'
import { readInternalStoredDataV2 } from './ConfigurationStorageDataV2'
import { upgradeStorageData } from './dataConversion'

export const readInternalStoredData = (manCode: ManCode) => upgradeStorageData(readInternalStoredDataV2(manCode) ?? readInternalStoredDataV1(manCode))
